import { getTextStyle, handleTooltipFormatting } from "../../utils";

export const pie = (
  props: { [key: string]: any } = {},
  data: { [key: string]: { [key: string]: any } | string[] } = {},
) => {
  const legendTextStyle = getTextStyle(props, "legend");

  let legendOptions: Record<string, unknown> = {
    show: props.showLegend,
    type: "scroll",
    itemGap: 16,
    textStyle: legendTextStyle,
  };

  switch (props.legendPosition) {
    case "bottom":
      legendOptions = { ...legendOptions, bottom: 0 };
      break;
    case "top":
      legendOptions = { ...legendOptions, top: 0 };
      break;
  }

  return {
    tooltip: {
      trigger: "item",
      formatter: (params: Record<string, string | number>) =>
        handleTooltipFormatting(params, props.prefix, props.suffix),
    },
    title: {
      show: false,
    },
    textStyle: {
      color: props.color,
      fontFamily: props.fontFamily,
    },
    series: data.series || [],
    legend: legendOptions,
    animation: props.animation,
    grid: { containLabel: true },
    labelLayout: { hideOverlap: true },
  };
};
